import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { EligibilitycalculatorsearchComponent } from './components/eligibilitycalculatorsearch/eligibilitycalculatorsearch.component';
import { AwardletterComponent } from './components/awardletter/awardletter.component';

// Angular modules
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Kendo modules
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';

// External modules
import { GadoeFrameworkModule } from 'gadoe-framework';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// Utilities
import { DatePipe } from '@angular/common';
import { ConfigService } from './shared/services/config.service';
import { Config } from './shared/config';

export function initializeApp(configService: ConfigService) {
  return () => configService.loadConfig().then((settings) => {
    Config.appSettings = settings;
    Config.ROOT_URL = settings?.apiURL || '';
    Config.calculatorInquiryFormUrl = settings?.calculatorInquiryFormUrl || '';

    console.log('APP_INITIALIZER settings:', settings);
    console.log('APP_INITIALIZER ROOT_URL:', Config.ROOT_URL);
  });
}

@NgModule({
  declarations: [
    AppComponent,
    EligibilitycalculatorsearchComponent,
    AwardletterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    NotificationModule,
    GridModule,
    DialogsModule,
    UploadsModule,
    TooltipsModule,
    DatePickerModule,
    PDFExportModule,
    GadoeFrameworkModule,
    NgbModule,
    FontAwesomeModule
  ],
  providers: [
    DatePipe,
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
